import { apiInterfaceForJson } from '../common/apiManager';

export const getCheckoutSessionId = (orderInfo) => {
    return apiInterfaceForJson('/order/v1/getCheckoutSessionId', 'POST', orderInfo);
};

export const successPayment = (orderInfo) => {
    return apiInterfaceForJson('/order/v1/successPayment', 'POST', orderInfo);
};
